import React, {type JSX} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {useGuestPortalStore} from '../../../store';
import {PAGE_TYPE} from '../../../constants/types';
import BaseModalWindow from './baseModalWindow';

const TITLE = 'Attempts limit reached';
const DESCRIPTION =
  'You have reached your limit of attempts to enter the patient information. Please contact Health Bank One support.';

function ContactSupportModalWindow(): JSX.Element {
  const isOpenContactSupportModalWindow = useGuestPortalStore(
    state => state.contactSupportModal
  );
  const setIsOpenContactSupportModalWindow = useGuestPortalStore(
    state => state.setContactSupportModal
  );
  const setPageType = useGuestPortalStore(state => state.setPageType);

  const onClickContactSupportBtn = () => {
    window.open('https://support.healthbankone.com/', '_blank', 'noopener');
    setPageType(PAGE_TYPE.LOGIN);
    setIsOpenContactSupportModalWindow(false);
  };

  return (
    <BaseModalWindow open={isOpenContactSupportModalWindow}>
      <>
        <Typography component="h6" variant="h6">
          {TITLE}
        </Typography>
        <Typography marginTop={2}>{DESCRIPTION}</Typography>
        <Box display="flex" marginTop={5} justifyContent="flex-end">
          <Button
            variant="contained"
            data-testid="modal-contact-support-btn"
            size="presized"
            onClick={onClickContactSupportBtn}
          >
            Contact Support
          </Button>
        </Box>
      </>
    </BaseModalWindow>
  );
}

export default ContactSupportModalWindow;
